/* Internal component for handling different button style rendering make sure to add button components to the widgets and import them here to be built through this tool. */
import React from "react"
import iconButton from "../../widgets/iconButton/iconButton"
import LinkCtaButton from "../../widgets/linkCtaButton/LinkCTAButton"
import SolidCtaButton from "../../widgets/solidCtaButton/SolidCtaButton"
import TransparentCTAButton from "../../widgets/transparentCtaButton/TransparentCTAButton"

const Buttons = ({ buttonProps }) => {
  const Components = {
    'link_cta': LinkCtaButton,
    'linked_cta': LinkCtaButton,
    'solid_cta': SolidCtaButton,
    'transparent_cta': TransparentCTAButton,
    'icon_button': iconButton,
  }
  if (typeof Components[buttonProps.component] !== "undefined") {
    const Component = Components[buttonProps.component]
    return <Component buttonProps={buttonProps} key={buttonProps._uid} />
  } else {
    return (
      <div className="button">
        <TransparentCTAButton buttonProps={buttonProps}></TransparentCTAButton>
      </div>
    )
  }
}

export default Buttons
